<template>
  <div>
    <v-layout>
      <v-btn icon class="primary--text mt-1 mr-2" :to="`/`" router exact>
        <v-icon>keyboard_backspace</v-icon>
      </v-btn>

      <page-title>Access Keys</page-title>

      <div class="ml-4 mt-1 mb-2">
        <v-btn class="primary--text mr-3" text @click="refresh()">
          <v-icon class="mr-1">refresh</v-icon>
          Refresh
        </v-btn>
        <create-user-access-key></create-user-access-key>
      </div>
    </v-layout>

    <v-layout>
      <page-subtitle
        >Create, view and manage your access keys. These keys can be used for CLI commands and API requests.
        Learn more about access
        keys in the official
        <a
          href="https://docs.synpse.net/manage/access-tokens"
          class="ml-1"
          target="_blank"
          rel="noopener"
          >documentation</a
        >.

        </page-subtitle>
    </v-layout>

    <!-- delete confirmation modal -->
    <v-dialog v-model="modal" max-width="500px">
      <v-card>
        <v-card-title>Confirmation Required</v-card-title>
        <v-card-text>
          Are you sure want to delete access key '{{ removingUserAccessKey.id }}'?
        </v-card-text>
        <v-card-actions>
          <v-btn text v-on:click.native="modal = false" class="primary">Cancel</v-btn>
          <v-spacer>
          </v-spacer>
          <v-btn v-on:click.native="deleteUserAccessKey(removingUserAccessKey)" text class="primary--text">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout class="mt-2">
      <div class="tbcard">
        <div v-if="!loading && userAccessKeys.length === 0">
          <v-container fill-height align-content-space-around>
            <v-layout row justify-center>
              <v-flex xs4 class="text-md-center mt-5">
                <span class="headline">No Access Keys</span>
                <span class="subheading">
                  <page-subtitle class="text-md-center">
                    Access keys are used to authenticate CLI commands and API requests.
                  </page-subtitle>
                </span>
              </v-flex>
            </v-layout>
          </v-container>
        </div>

        <v-card v-else outlined>
          <v-data-table
            :key="tableKey"
            :headers="headers"
            :items="userAccessKeys"
            :search="e3"
          >
            <template v-slot:[`item.id`]="{ item }">
                {{ item.id }}
            </template>

            <template v-slot:[`item.createdAt`]="{ item }">
              <v-tooltip top :key="item.id">
                <template v-slot:activator="{ on: tooltip }">
                  <span v-on="{ ...tooltip }">
                    {{ item.createdAt | ago }}
                  </span>
                </template>
                <span>{{ item.createdAt | date }}</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-menu class="items" top left transition="v-slide-y-transition">
                <template v-slot:activator="{ on: on }">
                  <v-btn
                    icon
                    v-on="on"
                    :class="
                      $store.state.theme === 'light' ? 'secondary--text' : ''
                    "
                  >
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list dense>
                  <v-list-item @click="removeUserAccessKeyIntent(item)">
                    <v-list-item-title>delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-layout>
  </div>
</template>

<style lang="stylus">
.tbcard {
  width: 100%;
  display: block;
}
</style>

<script>
import PageSubtitle from '../PageSubtitle';
import PageTitle from '../PageTitle';
import CreateUserAccessKey from './CreateUserAccessKey.vue';

export default {
  components: {
    PageSubtitle,
    PageTitle,
    CreateUserAccessKey,
  },
  data() {
    return {
      tableKey: '',
      e3: null,
      headers: [
        { text: 'ID', align: 'left', value: 'id', sortable: true },
        { text: 'Description', value: 'description', align: 'left' },
        { text: 'Created', value: 'createdAt', align: 'left' },
        { text: '', value: 'actions', sortable: false, align: 'right' }
      ],
      modal: false,
      removingUserAccessKey: {
        id: '',
        name: ''
      }
    }
  },

  computed: {
    loading() {
      return this.$store.state.iam.loading
    },
    userAccessKeys() {
      return this.$store.state.iam.userAccessKeys
    },
  },

  mounted() {
    this.refresh()
  },

  methods: {
    refresh() {
      this.$store.dispatch('ListUserAccessKeys')
    },
    removeUserAccessKeyIntent (removingUserAccessKey) {
      // assigning removing input val
      this.removingUserAccessKey = removingUserAccessKey
      this.modal = true
    },
    deleteUserAccessKey () {
      this.$store.dispatch('DeleteUserAccessKey', this.removingUserAccessKey).then(() => {
        this.refresh()
        // closing confirmation modal
        this.modal = false
      })
    }
  }
}
</script>
